import { render, staticRenderFns } from "./FederationControl.vue?vue&type=template&id=2d64b46e&scoped=true&"
import script from "./FederationControl.vue?vue&type=script&lang=js&"
export * from "./FederationControl.vue?vue&type=script&lang=js&"
import style0 from "./FederationControl.vue?vue&type=style&index=0&id=2d64b46e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d64b46e",
  null
  
)

export default component.exports